import { merge } from "lodash"
import defaultConfig from "./configuration/default"

export default {
  materialType: "international-treaty-consolidated",
  languages: [
    "fi",
    "sv",
  ],
  title: "label.internationalTreatyConsolidated",
  description: "description.internationalTreatyConsolidated",
  configuration: merge({}, defaultConfig, {
    actions: { languages: true },
    listing: {
      caption: true,
      title: true,
      type: true,
    },
  }),
}
